import React, { useReducer, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import './Duplicate-popup.scss';
import { Button } from '@material-ui/core';
import CustomTextField from '../form-controls/custom-text-field/Custom-Text-Field';

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const DuplicatePopupModel = (props) => {
  const { duplicatePopUp, onDuplicate, onDuplicateCancel } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Name',
      errors: {},
      validations: ['required'],
      tab: 0,
    },
  });
  const handleClose = () => {
    onDuplicateCancel();
  };

  const onDuplicateClick = (e, name) => {
    onDuplicate(e, name);
  };

  const body = (
    <div style={modalStyle} className={classes.paper}>
      <div className='delete-popup'>
        <div className='delete-popup-title'>
          {duplicatePopUp?.title} <br />
          {duplicatePopUp.name}?
        </div>
        <p className='delete-popup-description'>{duplicatePopUp.description}</p>
        <div className='col-md-12 mb-3 mt-3'>
          <CustomTextField
            item={formData.name}
            handleInputChange={(e) => {
              setFormData({ name: e });
            }}
            maxLength={15}
            endAdornment={true}
            characterCount={true}
          />
        </div>
        <div className='col-md-10 offset-1 d-flex justify-content-around px-4 mt-4'>
          <Button variant='outlined' size='large' color='secondary' onClick={(e) => handleClose()}>
            Cancel
          </Button>
          <Button
            variant='contained'
            size='large'
            color='primary'
            disabled={formData.name.value === '' || Object.values(formData.name.errors || {}).some(Boolean)}
            onClick={(e) => onDuplicateClick(e, formData.name.value)}
          >
            Duplicate
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal open={duplicatePopUp.duplicateStatus} onClose={handleClose}>
        {body}
      </Modal>
    </div>
  );
};

export default DuplicatePopupModel;
